<template>
  <div id="product">
    <div class="header">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item><strong style="font-size: 16px;">展品列表</strong></el-breadcrumb-item>
      </el-breadcrumb>
      <el-button class="button" type="primary" @click="addProduct" style="margin-right:20px">新增</el-button>
    </div>
    <ul class="cards">
      <div class="noData" v-if="productList.length <= 0 ">您没有上传展品信息</div>
      <li v-for="(val) in productList" :key="val.id">
        <div :body-style="{ padding: '0px' }" class="cardItem">
          <div class="img"><img :src="val.productImg"></div>
          <div class="rightBox">
            <!-- <h3>公司名： {{val.clgComName}}</h3> -->
            <h3>展品名称： {{val.pdtName}}</h3>
            <p>展位号： <span class="blue">{{ userInfo.bthCode || '暂无' }}</span></p>
            <div class="text">产品说明： {{val.pdtIntro}}</div>
            <div class="bottom clearfix">
              <el-button class="button" type="primary" @click="edit(val)">修改</el-button>
              <el-button class="button" @click="del(val)">删除</el-button>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import api from '@/api'
import tools from '../../utils/tools.js';
export default {
  name: 'Product',
  data() {
    return {
      productList:[],
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      total:''
    }
  },
  mounted() {
    this.isPC = tools.isPC()
    this.getList()
  },
  methods: {
    addProduct() {
      if(this.total < 6){
        this.$router.push('/addProduct')
      }else{
        this.$message.error('展品只能上传6个，名额已满。')
      }
    },
    edit(val){
      this.$router.push({path: '/addProduct', query: {id: val.id}});
    },
    //获取数据
    getList(){
          api.productlist({
            pageIndex:"0"
          }).then((res)=>{
              if(res.data.code =='200'){
                var _data = res.data.data
                this.productList = _data.list
                this.total = _data.total
//              console.log(this.total)
              }
          })
    },
    del(val){
        this.$confirm('确定删除该展品？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          api.deleteproduct({pdtID: parseInt(val.id) }).then(res => {
            if (res.data.code === 200) {
              this.$notify({
                title: '成功',
                message: '删除成功',
                type: 'success'
              });
              this.getList()
            }
          })
        }).catch(() => {});
    }
  }
}
</script>
<style lang="less" scoped>
.noData{
  text-align: center;
  width: 100%;
  font-size: 16px;
  color:#999
}
#product{
  padding-top:30px;
  .header{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .cardItem{
      -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      display: flex;
      margin-bottom: 50px;
      padding: 20px;
      border-radius: 10px;
  }
  .cardItem .img{
      width:200px;
      height:200px;
      margin-right: 10px;
      text-align: center;
  }
  .cardItem .img img{
      max-width:100%;
      max-height:100%;
  }
  .rightBox{
    width: 65%;
    font-size:14px;
    position: relative;
    padding: 14px;
    p{
      padding-top:15px;
    }
    .bottom{
        padding-top: 20px;
    }
    .text{
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
    }
  }
  
  .mart30{
    padding-top:30px;
  }
  .blue{
    color:#409EFF
  }
  .cards{
    display: flex;
    padding-top:30px;
    flex-wrap: wrap;
    >li{
      padding: 0 20px;
      width: 50%
    }
  }
  @media screen and (max-width:540px){
    .cards>li{
      width: 100%;
      padding:0;
      .img{
        width:90px;
        height: auto;
        background: #fff;
        img{
          max-width: 90px;
        }
      }
    }
    .rightBox{
      padding:0;
      font-size: 14px;
      h3{
        font-size: 14px;
      }
      >p{
        padding-top:10px;
      }
      .el-button{
        padding:8px 16px
      }
    }
  }
}
</style>
